<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="heartbeat_accoff" class="col-sm-2 control-label">Heart Beat (min):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.heartbeat_accoff"  class="form-control" id="heartbeat_accoff" >
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Bus} from '../../../../class/bus';
    import {X3tech} from "../../../../class/x3tech";
    export default {
        name: "Hbt",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await X3tech.sendHbt(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
